import React from "react";
import "./style.scss";
import DOMPurify from "dompurify";

export default function TabSelector({
  selectedTab,
  setSelectedTab,
  tabContent,
}) {
  return (
    <div className="tab-selector">
      {tabContent.map((e, index) => (
        <button
          key={index}
          className={`tab-button ${selectedTab === index ? "active" : ""}`}
          onClick={() => setSelectedTab(index)}
        >
          <div className="tab-button-inner">
            <div className="icon">
              {selectedTab === index ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="8"
                  viewBox="0 0 16 8"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 1.04889L13.1743 0.5L16 4L13.1743 7.5L12.5 6.95111L14.4789 4.5L0.5 4.5V3.5L14.479 3.5L12.5 1.04889Z"
                    fill="#1D1D1B"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="2"
                  viewBox="0 0 16 2"
                  fill="none"
                >
                  <path d="M0 1H16" stroke="#3D65AB" />
                </svg>
              )}
            </div>
            <div
              className="inner-tab-content"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(e.includes("<p>") ? e : `<p>${e}</p>`),
              }}
            />
          </div>
        </button>
      ))}
    </div>
  );
}
